// extracted by mini-css-extract-plugin
export var textInput = "_d0-0";